import "./utils/cefRegister.js";
import "./utils/consoleParamFixer.js";
import "@lib/ModuleSystem/applyApiUrl.js";
import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";

import "./assets/main.scss";

import "@mdi/font/css/materialdesignicons.css";
import modules from "./imports.js";
import { ModuleManager, ServiceTypes } from "@module-system";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import { mdi, aliases } from "vuetify/iconsets/mdi";
import { VSkeletonLoader } from "vuetify/labs/VSkeletonLoader";

import { getElasticConfig } from "./tracing/elasticApmSetup.js";
import { ApmVuePlugin } from "@elastic/apm-rum-vue";

import i18n from "./i18n.js";

import "./polyfills.js";

if (window.CONFIG.APP_NAME) window.document.querySelector("title").innerText = window.CONFIG.APP_NAME;

import "sweetalert2/dist/sweetalert2.min.css";
import axios from "axios";
import { EventManager } from "@events";
import { useLicenseState } from "./stores/licenseState";
import { replaceLocalStorageWithPersistedRef } from "./utils";
import configurationProvider from "./Core/configurationProvider";

configurationProvider.init();
const pinia = createPinia();
const licenseState = useLicenseState(pinia);
import { dynamicRouter } from "./router/index.js";

licenseState.initialize().then(async () => {
  async function loadConfigOverrides() {
    let res = await axios.get("/api/config/get-config-overrides/" + ServiceTypes.WebApp);

    if (!res.data.success) return;

    let configOverrides = res.data.data;

    for (const override of configOverrides) {
      window.CONFIG[override.key] = override.value;
    }

    if (window.CONFIG.APP_NAME) window.document.querySelector("title").innerText = window.CONFIG.APP_NAME;
  }

  await replaceLocalStorageWithPersistedRef();
  await loadConfigOverrides();

  ModuleManager.registerModules(modules).then(async () => {
    EventManager.rootEventEmitter().emit("config-overrides-loaded");

    await ModuleManager.registerModule(import("./Core"));

    const router = dynamicRouter();

    const vuetify = createVuetify({
      components: {
        VSkeletonLoader,
      },
      theme: {
        defaultTheme: "dark",
      },
      icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
          mdi,
        },
      },
    });

    const app = createApp(App);

    app.use(i18n);
    app.use(vuetify);
    app.use(pinia);
    app.use(router);

    var elasticConfig = getElasticConfig();

    if (elasticConfig.active) {
      // get rum_trcId,rum_spnId,rum_smpld from url query
      var urlParams = new URLSearchParams(window.location.search);
      var rum_trcId = urlParams.get("rum_trcId");
      var rum_spnId = urlParams.get("rum_spnId");
      var rum_smpld = urlParams.get("rum_smpld");

      app.use(ApmVuePlugin, {
        router,
        config: {
          ...elasticConfig,
          pageLoadTraceId: rum_trcId,
          pageLoadSpanId: rum_spnId,
          pageLoadSampled: rum_smpld,
        },
      });
    }

    app.mount("#app");
  });
});
